import { render } from "./RuleCard.vue?vue&type=template&id=5e3a30e8&scoped=true&ts=true"
import script from "./RuleCard.vue?vue&type=script&lang=ts"
export * from "./RuleCard.vue?vue&type=script&lang=ts"

import "./RuleCard.vue?vue&type=style&index=0&id=5e3a30e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3a30e8"]])

export default __exports__